import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import MVP from "./pages/MVP";
import "./App.css";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/try" element={<MVP />} />
    </Routes>
  );
}
